import { Link } from "react-router-dom";
import { useReveal } from "../lib/useReveal";
import { ShieldCheck } from "lucide-react";
import { TRUST_SIGNALS } from "../data/trustSignals";
import { PRIVACY_PROMISE_DETAILS } from "../data/privacyPromiseDetails";

export default function PrivacyPromise() {
    const ref = useReveal();

    return (
        <section
            ref={ref}
            id="privacy-promise"
            data-testid="privacy-promise-section"
            className="py-20 md:py-24 bg-muted/30 border-y scroll-mt-24"
        >
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="reveal rounded-[2rem] border bg-card p-8 md:p-10 lg:p-12">
                    <div className="max-w-3xl">
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-5">
                            <ShieldCheck className="w-4 h-4" />
                            Our Privacy Promise
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight leading-tight">
                            Your recovery story belongs to you — not advertisers, insurers, or
                            strangers.
                        </h2>
                        <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
                            Journals and Hope conversations are{" "}
                            <strong className="font-semibold text-foreground">
                                fully encrypted in transit and at rest
                            </strong>
                            . We do not claim impossible guarantees — but we do commit to
                            privacy-first defaults and plain-language answers.
                        </p>
                    </div>

                    <ul className="mt-10 grid sm:grid-cols-2 gap-4">
                        {TRUST_SIGNALS.map((item) => (
                            <li
                                key={item}
                                className="flex items-start gap-3 rounded-2xl border bg-background/60 px-4 py-4"
                            >
                                <ShieldCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                                <span className="text-foreground font-medium leading-relaxed text-sm">
                                    {item}
                                </span>
                            </li>
                        ))}
                    </ul>

                    <div className="mt-10 pt-10 border-t grid md:grid-cols-2 gap-6">
                        {PRIVACY_PROMISE_DETAILS.map((item) => (
                            <div key={item.title}>
                                <h3 className="font-semibold text-foreground">{item.title}</h3>
                                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                                    {item.body}
                                </p>
                            </div>
                        ))}
                    </div>

                    <p className="mt-10 text-sm text-muted-foreground leading-relaxed">
                        Read the full{" "}
                        <Link
                            to="/privacy-policy"
                            className="font-semibold text-primary hover:underline"
                        >
                            Privacy Policy
                        </Link>{" "}
                        for more detail on collection, retention, and your rights.
                    </p>
                </div>
            </div>
        </section>
    );
}
